import * as React from "react";

import { EmailAndRemindersProps } from "./email-and-reminders.types";
import { useEmailAndRemindersController } from "./email-and-reminders.controller";
import { PatientEmailSettings } from "./components/patient-email-settings";
import { AutomaticReminderSettings } from "./components/automatic-reminder-settings";

import { EmailNotifyOnSubmit } from "./components/email-notify-on-submit";

import "./email-and-reminders.styles.scss";

export const EmailAndReminders: React.FC<EmailAndRemindersProps> = (props) => {
  const { questionnaire, onChange, getFolderFields, getFolders, showConfirmMessage, onMakeUncompletedInactiveConfirm, errors } = props;

  const { emailTemplates } = useEmailAndRemindersController(props);

  return (
    <div className="FhqDesignToolEmailAndReminders">
      <PatientEmailSettings emailTemplates={emailTemplates} questionnaire={questionnaire} onChange={onChange} />
      <AutomaticReminderSettings
        questionnaire={questionnaire}
        onChange={onChange}
        getFolderFields={getFolderFields}
        getFolders={getFolders}
        showConfirmMessage={showConfirmMessage}
        onMakeUncompletedInactiveConfirm={onMakeUncompletedInactiveConfirm}
        errors={errors}
      />
      <EmailNotifyOnSubmit questionnaire={questionnaire} onChange={onChange} errors={errors} />
    </div>
  );
};
